<template>
	<div class="machineinfo">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="400px" :close="handleClose">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">&emsp;*</span>机台号：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.machineCode" class="inputWidth" placeholder="机台号" ></el-input>
					</dd>
				</dl>
				<dl v-if="dialogmd5Visible">
					<dt><span class="checktip">*</span>机台唯一号：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.md5" class="inputWidth" placeholder="机台唯一码" ></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;*</span>省名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.province" class="inputWidth" placeholder="省名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;*</span>市名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.city" class="inputWidth" placeholder="市名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>详细地址：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.address" class="inputSmall" placeholder="详细地址"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;*</span>商户名：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.commercialName" class="inputSmall" placeholder="商户名"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;*</span>负责人：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.principal" class="inputWidth" placeholder="负责人"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>联系电话：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.phoneNumber" class="inputWidth" placeholder="联系电话"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>支付链接：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.qrcodeUrl" class="inputWidth" placeholder="支付链接"></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  	</span>
		</el-dialog>
		<!--导航条-->
		<!--<div>
			<navZcy v-bind:num="6"></navZcy>
			<management></management>
		</div>-->
		<div class="dataTag">
		<div class="handle">
			<div class="fl">
				<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
				<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
			</div>
			<div class="handleBtn fr">
				<el-button type="primary" size="small" @click="handleAdd">新增</el-button>
				<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
			</div>
		</div>
		<!--零件筛选-->
		<div class="filtrateMain">
			<el-row :gutter="15" style="text-align: center;">
				<el-col :span="4">
					<el-input v-model="filtrateData.principal" placeholder="负责人"></el-input>
				</el-col>
				<el-col :span="4">
					<el-input v-model="filtrateData.phoneNumber" placeholder="联系方式"></el-input>
				</el-col>
				<el-col :span="4">
					<el-input v-model="filtrateData.machineCode" placeholder="机台号"></el-input>
				</el-col>
				<el-col :span="4">
					<el-input v-model="filtrateData.md5" placeholder="机台唯一号"></el-input>
				</el-col>
				<el-col :span="4" style="line-height: 40px;">
					<el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
					<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
				</el-col>
			</el-row>
			<!--筛选结束-->
		</div>
		<!--列表内容-->
		<div class="tableData" style="text-align: center;">
			<el-table
					ref="multipleTable"
					:data="tableData"
					border
					@selection-change="handleSelectionChange"
					style="width: 100%;border-bottom: 1px solid #ddd;">
				<el-table-column type="selection" width="50px">
				</el-table-column>
				<el-table-column type="index" label="序号" width="80px">
				</el-table-column>
				<el-table-column prop="province" label="省" width="100px">
				</el-table-column>
				<el-table-column prop="city" label="市" width="100px">
				</el-table-column>
				<el-table-column prop="address" label="地址" width="200px">
					<template slot-scope="scope">
						<input class="disabledInput" :value="scope.row.address" disabled v-if="scope.row.address"></input>
					</template>
				</el-table-column>
				<el-table-column prop="commercialName" label="商户名" width="100px">
				</el-table-column>
				<el-table-column prop="principal" label="负责人" width="100px">
				</el-table-column>
				<el-table-column prop="phoneNumber" label="联系电话" width="108px">
				</el-table-column>
				<el-table-column prop="md5" label="机台唯一号" width="108px">
				</el-table-column>
				<el-table-column prop="machineCode" label="机台号" width="100px">
				</el-table-column>
				<el-table-column prop="qrcodeUrl" label="支付二维码" width="100px">
					<template slot-scope="scope">
						<input class="disabledInput" :value="scope.row.qrcodeUrl" disabled v-if="scope.row.qrcodeUrl"></input>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="100px">
				</el-table-column>
				<el-table-column prop="qrcodeUpdateTime" label="修改时间" width="100px">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
						<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--分页-->
		<div class="page">
			<el-pagination
					background
					:current-page="tableDataArr.currentPage"
					:page-sizes="[10,20,30,40]"
					:page-size="tableDataArr.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="tableDataArr.totalSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
	</div>
</template>

<script>
import axios from 'axios'
import management from './management.vue'
import navZcy from './nav.vue'
export default{
	data() {
		return {
			dialogTitle: '',
			dialogVisible: false,
			dialogmd5Visible:false,
			tableDataArr: {
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			filtrateData: {},
			tableData: [],
			dialogData: {},
			multipleSelection: []
		}
	},
	methods: {
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		getMachineinfo() {
			var data = {
				principal: this.filtrateData.principal==undefined?this.filtrateData.principal:this.filtrateData.principal.trim(),
				phoneNumber: this.filtrateData.phoneNumber==undefined?this.filtrateData.phoneNumber:this.filtrateData.phoneNumber.trim(),
				machineCode: this.filtrateData.machineCode==undefined?this.filtrateData.machineCode:this.filtrateData.machineCode.trim(),
				md5: this.filtrateData.md5==undefined?this.filtrateData.md5:this.filtrateData.md5.trim(),
				currentPage: this.tableDataArr.currentPage,
				pageSize: this.tableDataArr.pageSize
			}
			this.$http.post("zcvrVideoApi/machine/inquiryMachineinfo/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
		  	(success)=>{
//				console.log(success)
		  	    if(success.body.msg!="ok"){
		  	    		this.tableDataArr = {
		  	    			currentPage: 1,
							pageSize: 10,
							totalSize: 0
		  	    		}
	  					this.tableData = []
						this.$message({
							type: 'error',
							message: success.data.msg
						});
						if(success.data.msg=="该SessionId已经超时"){
				  			this.$message.error("登录超时！请重新登录");
				  			this.$router.push({path: '/',query: ''})
				  		}
  				}else {
  					this.tableDataArr = success.body.data
  					this.tableData = this.tableDataArr.items
  				}

  			},
  			(error)=>{
  				console.log("数据连接失败")
  			})
		},
		//筛选查询
		handleSearch() {
			this.tableDataArr.currentPage = 1
			this.getMachineinfo()
		},
		//重置筛选
		handleReset() {
			this.filtrateData = {}
		},
		//编辑机台信息
		handleEdit: function(index, row) {
			this.dialogTitle = "编辑机台信息";
			this.dialogData = {
				id: row.id,
				province: row.province,
                city: row.city,
                address: row.address,
                commercialName: row.commercialName,
                principal: row.principal,
              	phoneNumber: row.phoneNumber,
                machineCode: row.machineCode,
				md5: row.md5,
				qrcodeUrl: row.qrcodeUrl,
				qrcodeUpdateTime: row.qrcodeUpdateTime
			};
			this.dialogVisible = true;
			this.dialogmd5Visible = false;
			setTimeout(function(){
				$('.input').focus()
			},100)
		},
		//确定添加/编辑
		handleConfirm: function() {
			let data = {
				id: this.dialogData.id,
				province: this.dialogData.province,
                city: this.dialogData.city,
                address: this.dialogData.address,
                commercialName: this.dialogData.commercialName,
                principal: this.dialogData.principal==undefined?this.dialogData.principal:this.dialogData.principal.trim(),
              	phoneNumber: this.dialogData.phoneNumber==undefined?this.dialogData.phoneNumber:this.dialogData.phoneNumber.trim(),
                machineCode: this.dialogData.machineCode==undefined?this.dialogData.machineCode:this.dialogData.machineCode.trim(),
				md5: this.dialogData.md5==undefined?this.dialogData.md5:this.dialogData.md5.trim(),
				qrcodeUrl: this.dialogData.qrcodeUrl,
				qrUpdateTime: this.dialogData.qrUpdateTime
			}
			console.log(data)
			let url = "zcvrVideoApi/machine/initMachine/"
			this.$http.post(url,data,{emulateJson:true}).then(
		  	(success)=>{
//				console.log(success)
		  	    if(success.body.msg!="ok"){
						this.$message({
							type: 'error',
							message: success.data.msg
						});
						if(success.data.msg=="该SessionId已经超时"){
				  			this.$message.error("登录超时！请重新登录");
				  			this.$router.push({path: '/',query: ''})
				  		}
  				}else {
					this.dialogVisible = false
					this.dialogmd5Visible=false
  					this.getMachineinfo()
  				}
  			},
  			(error)=>{
  				console.log("数据连接失败")
  			})
		},
		//复选框选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除图片风格
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该机台信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "zcvrVideoApi/machine/deleteMachineinfo/"+sessionStorage.getItem('sessionId')+"/"+id
					this.$http.get(url,{emulateJson:true}).then(
				  			(success)=>{
//				  				console.log(success)
				  				if(success.body.msg=="ok"){
				  					this.$message({
							          message: '删除成功',
							          type: 'success'
							       });
							        this.getMachineinfo()
				  				}else{
				  					this.$message({
							          message: success.data.msg,
							          type: 'error'
							        });
					  				if(success.data.msg=="该SessionId已经超时"){
							  			this.$message.error("登录超时！请重新登录");
							  			this.$router.push({path: '/',query: ''})
							  		}
				  				}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.getMachineinfo()
		},
		//改变显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.getMachineinfo()
		},
		//新增机台信息
		handleAdd(){
			this.dialogTitle = "新增机台信息";
			this.dialogData = {};
			this.dialogVisible = true
			this.dialogmd5Visible=true
		}
	},
	mounted() {
		this.getMachineinfo()
	},
	components: {
		management,
		navZcy
	}
}
</script>

<style scoped="scoped">
.fl {
	float: left;
}
.fr {
	float: right;
}
.cf {
	overflow: hidden;
}
.title{
	padding: 20px 0;
}
.dataTag{
	width: 1400px;
	border: 1px solid #ccc;
	margin: auto;
	margin-top: 30px;
}
.dataTag .handle{
	height: 60px;
	line-height: 60px;
	background: #ededed;
	padding: 0 40px;
	border-bottom: 1px solid #ccc;
}
a {
	margin: 3px;
}
.page{
	text-align: center;
	padding: 10px 0;
	background: rgb(246, 247, 249);
}
.disabledInput{
	width: 100%;
	border: none;
	background: rgba(0,0,0,0);
	text-align: center;
}

.filtrateMain{
	background: #fff;
	padding: 10px;
}
.filtrateMain .inputWidth{
	width: 90%;
}
</style>
